import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

interface UseGetResponseTimeAnalysisParams {
  fromDate?: string
  pageId: string
  // Time-of-day window: all hours, 09:00–19:00, or 19:00–09:00.
  period?: 'overall' | 'morning' | 'evening'
  toDate?: string
  type: 'platform' | 'operator'
}

export const useGetResponseTimeAnalysisQuery = (
  params: UseGetResponseTimeAnalysisParams
) => {
  // The morning/evening period windows are evaluated in the viewer's timezone,
  // so the backend buckets by local hours rather than a fixed region.
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return useQuery({
    enabled: !!params.pageId && !!params.type,
    placeholderData: keepPreviousData,
    queryFn: async () => {
      try {
        const response = await analyticsApi().get(
          '/v1_private/inbox-analysis/response-time',
          {
            params: {
              fromDate: params.fromDate,
              pageId: params.pageId,
              period: params.period,
              toDate: params.toDate,
              type: params.type,
              tz: timezone,
            },
          }
        )
        return response.data
      } catch (error) {
        // On failure return null; the component falls back to empty data.
        console.warn('Response time analysis API request failed')
        return null
      }
    },
    queryKey: [
      QueryKey.GET_RESPONSE_TIME_ANALYSIS,
      params.pageId,
      params.type,
      params.fromDate,
      params.toDate,
      params.period,
      timezone,
    ],
  })
}
